import { useEffect } from 'react';

/**
 * @return {void}
 */
const useSmallFooter = () => {
  useEffect(() => {
    const footer = document.querySelector('.footer');

    footer.classList.add('footer--small');

    return () => {
      footer.classList.remove('footer--small');
    };
  }, []);
};

export default useSmallFooter;
